<template>
  <div>
      <opentrades v-if="api_name == 'opentrades'"></opentrades>
      <openorders v-if="api_name == 'openorders'"></openorders>
      <tradehistory  v-if="api_name == 'tradehistory'"></tradehistory>
      <placemarket v-if="api_name == 'placemarket'"></placemarket>
      <placepending v-if="api_name == 'placepending'"></placepending>
      <placestop  v-if="api_name == 'placestop'"></placestop>
      <placelimit v-if="api_name == 'placelimit'"></placelimit>
      <closetrade v-if="api_name == 'closetrade'"></closetrade>
      <modifyorder v-if="api_name == 'modifyorder'"></modifyorder>
      <cancelorder v-if="api_name == 'cancelorder'"></cancelorder>
  </div>
</template>

<script>
import opentrades from './trading/opentrades'
import openorders from './trading/openorders'
import tradehistory from './trading/tradehistory'
import placemarket from './trading/placemarket'
import placepending from './trading/placepending'

import placestop from './trading/placestop'
import placelimit from './trading/placelimit'
import closetrade from './trading/closetrade'
import modifyorder from './trading/modifyorder'
import cancelorder from './trading/cancelorder'
export default {
 name:'trading',
 props:['api_name'],
 components:{
     opentrades: opentrades,
     openorders: openorders,
     tradehistory: tradehistory,
     placemarket: placemarket,
     placepending: placepending,
     placestop: placestop,
     placelimit: placelimit,
     closetrade: closetrade,
     modifyorder: modifyorder,
     cancelorder: cancelorder,
 }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/trading.vue